import { render, staticRenderFns } from "./TheInvestments.vue?vue&type=template&id=0c10e3f7&"
import script from "./TheInvestments.vue?vue&type=script&lang=js&"
export * from "./TheInvestments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports